<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="cause_of_deaths"
      :loading="loading"
      :page="page"
      :page-count="numberOfPages"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                label="Descrição"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.description"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{ $t('buttons.new') }}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="getDataTable()"
            url="cause_of_deaths"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <CausaMorte
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, getDataTable()"
      />
    </Modal>
  </div>
</template>

<script>
import { getCauseOfDeaths } from "@/service/basic-registrations/PcrDeathCauseService";
import CausaMorte from "./PcrDeathCause.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";

export default {
  components: {
    ChangeStatus,
    CausaMorte,
    Menu,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      filterForm: {},
      headers: [
        { text: "Descrição", align: "start", value: "description" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      numberOfPages: 0,
      loading: true,
      options: {},
      sortBy: "name",
      cause_of_deaths: [],
      resource: {},
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "ParentescoForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.getDataTable();
    this.changeActionsData(this.actions);
  },

  methods: {
    ...mapActions(["changeActionsData"]),

    getDataTable() {
      this.loading = true;
      getCauseOfDeaths({
        description: this.filterForm.description || '',
        page: this.page,
      }).then((result) => {
        this.loading = false;
        this.cause_of_deaths = result;
      });
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    applyFilter() {
      this.getDataTable();
    },

    clearFilter() {
      this.filterForm = {};
      this.getDataTable();
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
